<template>
  <div
    class="row"
    data-test="what-members-say">
    <HomepageSection
      title="What Members Say"/>
    <div class="col-12">
      <BaseCarousel
        v-if="section"
        auto-scroll-behavior="continuous"
        :items="section.blocks"
        :items-per-slide="{mobile: 2, tablet: 3, desktop: 4}"
        :show-buttons="!isMobile"
        :show-indicators="false">
        <template #default="{ item }">
          <TestimonialCard
            v-if="item.image?.preprocessedUrl"
            :text="item.text"
            :image-url="item.image.preprocessedUrl"
            :image-alt-text="item.image.imageAltText"
            class="mb-xxl"/>
        </template>
      </BaseCarousel>
      <BaseCarousel
        v-else
        :items="Array(4).fill({})"
        :items-per-slide="{mobile: 2, tablet: 3, desktop: 4}"
        :show-indicators="false">
        <template #default>
          <PreviewImagePlaceholder/>
        </template>
      </BaseCarousel>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useGenericContentStore } from '@shared/stores/genericContent.js'
import useScreenSize from '@shared/composables/screenSize.js'
import BaseCarousel from '@shared/components/ADORN/BaseCarousel.vue'
import TestimonialCard from '@/homepage/components/sections/WhatMembersSay/TestimonialCard.vue'
import PreviewImagePlaceholder from '@shared/components/ADORN/PreviewImagePlaceholder.vue'
import HomepageSection from '@/homepage/components/HomepageSection.vue'

const store = useGenericContentStore()
const section = computed(() => store.whatMembersSaySection)
const { isMobile } = useScreenSize()
</script>
